import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'type',
      type: 'select',
      label: '素材类型',
      placeholder: '请选择类型',
      options: [
        { title: '图片', value: 2 },
        { title: '视频号', value: 3 },
        { title: '文字', value: 4 },
        { title: '图文', value: 5 }
      ],
      rules: { required: true, message: '素材类型是必选的', trigger: 'blur' }
    },
    {
      field: 'titles',
      ctrlField: 'type',
      type: 'textareas',
      label: '标题',
      multiple: true,
      multipleLimit: 3,
      filterable: true,
      placeholder: '请输入标题',
      rules: { required: true, message: '标题是必填的', trigger: 'blur' }
    },
    {
      field: 'validReplyDuration',
      type: 'number',
      label: '回复时限',
      placeholder: '请输入回复时限',
      rules: { required: true, message: '回复时限是必填的', trigger: 'blur' },
      suffix: '分钟'
    },
    {
      field: 'replyKeyword',
      type: 'input',
      label: '回复关键词',
      placeholder: '请输入回复关键词',
      suffix: '多个关键词用英文分号分割。例如：666;888'
    },
    {
      field: 'longterm',
      type: 'switch',
      label: '是否长效素材',
      activeValue: 1,
      inActiveValue: 0
    },
    {
      field: 'desc',
      type: 'textarea',
      label: '描述',
      placeholder: '请输入具体描述'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
